<template>
  <div class="avatar-image">
    <v-avatar
      :size="size || 200"
      :class="{
        borderBoxed: hasBorder,
        'avatar-image__contain': contain,
      }"
      :tile="contain"
    >
      <v-image 
        alt="Avatar" 
        :src="picture" 
        :waitLoading="waitLoading"
      />
    </v-avatar>
  </div>
</template>
<script>

export default {
  name: "AvatarComponent",
  props: {
    size: {},
    url: { type: String, default: null },
    hasBorder: { type: Boolean, default: false },
    contain: { type: Boolean, default: false },
    isMine: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    waitLoading: { type: Boolean, default: false }
  },
  computed: {
    picture() {
      if (this.isMine) return this.avatarUrl(this.$store.state.auth.user.picture)
      return this.avatarUrl(this.url);
    },
  },
};
</script>
